import { P2Alert, P2TextInput } from 'react-bootstrap-common-script';
import RadioGroup from '../../form/grouped/radio/radio-group';
import { Stamp_Duty_Valuation } from '../../../utils/shared-radio';
import { StampDutyValuationEnum } from '../../../models/enum/stamp-duty-valuation.enum';
import { StageBConveyancing } from '../../../models/classes/stage-b/review-endorse.class';
import { ApplicationStep3 } from '../../../models/classes/ApplicationStep3.class';
import { Helpers } from '../../../utils/helper';
import { InfoCard } from '../../info';
import { InfoCircle } from '../../../assets/svg';
import { useCallback } from 'react';

interface ValuationStampDutyFormProps{
  conveyancing_values: StageBConveyancing | ApplicationStep3;
  setFormValue: (value:StageBConveyancing | ApplicationStep3) => void;
  errors:any;
  forceError?:boolean;
}
function ValuationStampDutyForm({...props}:ValuationStampDutyFormProps) {
  const handleStampDutySelection = useCallback((value: string) => {
    props.setFormValue({...props.conveyancing_values, valuation: value as StampDutyValuationEnum, estimated_market_value: value !== StampDutyValuationEnum.own_opinion ? "" : props.conveyancing_values.estimated_market_value});
  },[props])
  const handleMarketValueChange = useCallback((value: string) => {
    let updatedValue = Helpers.formatCurrencyInput(value, false);
    props.setFormValue({...props.conveyancing_values, estimated_market_value: updatedValue});
  },[props])

  const handleMarketValueBlur = useCallback((value: string) => {
    if(value){
      let updatedValue = Helpers.formatCurrencyInput(value, true);
      props.setFormValue({...props.conveyancing_values, estimated_market_value: updatedValue});
    }
  },[props])

  return (
    <div>
      <div className="polymer-stamp-duty-radio">
        <RadioGroup style={{marginTop:24}} disabled={false} layout={'default'} items={Stamp_Duty_Valuation} onItemSelect={handleStampDutySelection} value={props.conveyancing_values.valuation} label={`Options to determine the market value of the flat:`} hasTooltip={true} tooltipContent={<>
          <div>As it is an IRAS requirement to pay for stamp duty, there is a need to select the basis of computation for the amount payable. IRAS has provided the following options below. Stamp duty should be paid based on the current/ open market value of the flat at the point of ownership change. Please contact IRAS for further enquiries on stamp duty.</div>
          <br />
          <div>IRAS treats non-stamping or under-stamping of dutiable instruments seriously. If a taxpayer is found to have avoided paying stamp duty or under-declared the market value of the property to avoid paying the correct stamp duty, hefty penalties of up to 4 times the amount of deficient duty prescribed under Stamp Duties Act will be imposed.</div>
        </>}/>
      </div>
      {props.forceError && !props.errors?.valuation?.isValid && 
        <div style={{ marginTop: 24 }}>
          <P2Alert variant={"danger"} text={"This is a required field."}></P2Alert>
        </div>
      }
      {props.conveyancing_values.valuation === StampDutyValuationEnum.own_opinion &&
      <>
          <div style={{margin: "24px 0 32px 39px"}}>
            <P2TextInput forceError={props.forceError} isError={!props.errors?.estimated_market_value?.isValid} errorMsg={props.errors?.estimated_market_value?.message} maxLength={30} required value={Helpers.formatThousandSeparator(props.conveyancing_values.estimated_market_value,"$ ")} name='estimated_market_value' label='Market value of the flat' type='text' onBlur={handleMarketValueBlur} onChange={handleMarketValueChange}/>
          </div>
          <InfoCard style={{ backgroundColor: "#FFF", marginBottom: 24 }} icon={<InfoCircle />} description={"IRAS treats non-stamping or under-stamping of dutiable instruments seriously. If it has been found that taxpayer has avoided paying stamp duty or under-declared the market value of the property to avoid paying the correct stamp duty, hefty penalties of up to 4 times the amount of deficient duty prescribed under the Stamp Duties Act would be imposed."} />
          </>
      }
    </div>
  )
}

export default ValuationStampDutyForm